import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/Sidebar";
import TotalMentorsIcon from "../../images/svgs/TotalMentorsIcon";
import TotalUsersIcon from "../../images/svgs/TotalUsersIcon";
import { fetchTotalUsersAndMentors } from "../../services/adminService";
import ComplainList from "../../components/Admin/ComplainList";
import SalesStatistics from "../../components/Admin/SalesStatistics";
import SecondaryLoader from "../../components/SecondaryLoader/SecondaryLoader";
import UsersCountries from "../../components/Admin/UsersCountries";
import AdminDashboardCard from "../../components/Admin/AdminDashboardCard";

const AdminDashboard = () => {
  const userId = useSelector((state) => state.auth.id);

  const {
    data: fetchUsersMentorsData,
    isLoading,
    error: fetchUsersMentorsError,
  } = useQuery({
    queryKey: ["totalUsersMentors"],
    queryFn: fetchTotalUsersAndMentors,
    enabled: !!userId,
  });

  const totalMentors = fetchUsersMentorsData?.mentors.total || 0;
  const completeMentors = fetchUsersMentorsData?.mentors.complete || 0;
  const inCompleteMentors = fetchUsersMentorsData?.mentors.incomplete || 0;
  const totalUsers = fetchUsersMentorsData?.users.total || 0;
  const completeUsers = fetchUsersMentorsData?.users.complete || 0;
  const inCompleteUsers = fetchUsersMentorsData?.users.incomplete || 0;

  const cardDetails = [
    {
      label: "TOTAL MENTORS",
      figure: totalMentors,
      complete: completeMentors,
      incomplete: inCompleteMentors,
      icon: <TotalMentorsIcon />,
    },
    {
      label: "TOTAL USERS",
      figure: totalUsers,
      complete: completeUsers,
      incomplete: inCompleteUsers,
      icon: <TotalUsersIcon />,
    },
  ];

  return (
    <Sidebar>
      <div className="p-6 flex flex-col gap-6">
        {fetchUsersMentorsError && (
          <div className="text-red-500 bg-red-100 p-3 rounded-md">
            Error fetching user and mentor data: {fetchUsersMentorsError}
          </div>
        )}

        {isLoading ? (
          <SecondaryLoader />
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {cardDetails.map((card, index) => (
                <AdminDashboardCard
                  key={index}
                  label={card.label}
                  figure={card.figure}
                  description={card.description}
                  icon={card.icon}
                  complete={card.complete}
                  incomplete={card.incomplete}
                />
              ))}
            </div>

            <div className="flex flex-col xl:flex-row w-full items-stretch gap-5">
              <div className="w-full xl:w-[70%]">
                <SalesStatistics />
              </div>
              <div className="w-full xl:w-[30%] min-h-full">
                <UsersCountries />
              </div>
            </div>

            <ComplainList />
          </>
        )}
      </div>
    </Sidebar>
  );
};

export default AdminDashboard;
